import { isStepNew, isStepRunning } from "../../utils/UnifiedViewUtils.js";
const startOperation = (step) => ({
  toStep: step,
  preserveBuckets: false
});
const isStartOperation = (operation) => !operation.fromStep && operation.toStep;
const stopOperation = (step) => ({
  fromStep: step,
  preserveBuckets: false
});
const isStopOperation = (operation) => operation.fromStep && !operation.toStep;
const advanceOperation = (fromStep, toStep) => ({
  fromStep,
  toStep,
  preserveBuckets: true
});
const isAdvanceOperation = (operation) => operation.fromStep && operation.toStep;
const operationsAreEqual = (a, b) => !!a && !!b && a.fromStep == b.fromStep && a.toStep == b.toStep && a.preserveBuckets == b.preserveBuckets;
const getOperationStepIds = (operation) => {
  if (!operation) {
    return [];
  }
  let ids = [];
  if (operation.fromStep) {
    ids.push(operation.fromStep);
  }
  if (operation.toStep) {
    ids.push(operation.toStep);
  }
  return ids;
};
const getOperationSetStepIds = (operationSet) => {
  var _a;
  return ((_a = operationSet == null ? void 0 : operationSet.experimentOperations) == null ? void 0 : _a.flatMap(getOperationStepIds).filter((value, index, arr) => arr.indexOf(value) === index)) || [];
};
const getValidExperimentOperations = (experiment) => {
  var _a;
  if (!experiment || !((_a = experiment == null ? void 0 : experiment.experimentSteps) == null ? void 0 : _a.length)) {
    return [];
  }
  const ops = [];
  const steps = experiment.experimentSteps;
  if (steps.every((s) => isStepNew(s))) {
    ops.push(startOperation(steps[0].id));
  } else if (steps.some((s) => isStepRunning(s))) {
    const runningStep = [...steps].reverse().find((s) => isStepRunning(s));
    const newStep = steps.find((s) => isStepNew(s));
    if (!!newStep) {
      ops.push(advanceOperation(runningStep.id, newStep.id));
    }
    ops.push(stopOperation(runningStep.id));
  }
  return ops;
};
export {
  advanceOperation,
  getOperationSetStepIds,
  getOperationStepIds,
  getValidExperimentOperations,
  isAdvanceOperation,
  isStartOperation,
  isStopOperation,
  operationsAreEqual,
  startOperation,
  stopOperation
};
//# sourceMappingURL=ExperimentOperationSet.model.js.map
